import { connect } from 'react-redux'
import Enums from '../../utils/enums'
import { columnTemplates } from '../../utils/templates'
import { fetchAllData, addTab, deleteProfile } from '../../core/core-actions'
import { createProfile, editProfile } from '../../core/core-utils'
import ListViewNestedTree from '../components/list-view-nested-tree'

const mapStateToProps = (state) => {
  if (!state[state.core.tabObject.activeApp]) {
    return {}
  }

  const appId = state.core.tabObject.activeApp

  return {
    appId,
    state: state[appId],
    theme: state.core.theme,
    viewTitle: Enums.APP_VIEW_TITLES[appId],
    viewColumns: columnTemplates[appId],
    viewColumnsNested: columnTemplates[appId + '_nested'],
    viewColumnsNested2: columnTemplates[appId + '_nested2'],
    searchFilter: state[appId].searchFilter
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAllData: (appId, callback) => {
      dispatch(fetchAllData(appId, callback))
    },
    addTab: (payload) => {
      dispatch(addTab(payload))
    },
    createProfile: (appId, callback) => {
      createProfile(appId, callback)
    },
    editProfile: (appId, recordId, viewData, callback) => {
      // Deep copy viewData to prevent changes to the original object
      // It will cause an immutable state error
      editProfile(appId, recordId, JSON.parse(JSON.stringify(viewData)), callback)
    },
    deleteProfile: (appId, activeKey, state, callback, deleteNumberProfile) => {
      dispatch(deleteProfile(appId, activeKey, state, callback, deleteNumberProfile))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListViewNestedTree)
